import React, { useEffect, useRef, useState } from 'react';
import { useApp } from '../context/AppContext';
import Icon from './Icon';
import './LiveChat.css';

const QUICK = [
  '查詢訂單狀態',
  '序號無法使用',
  'GASH 可儲哪些遊戲',
  '退款政策',
  '如何加入 VIP',
];

const BOT_REPLIES = {
  default: '您好，請問需要協助什麼？您可以點下方常見問題或直接輸入您的需求。',
  訂單: '請提供您的訂單編號（NX 開頭），會立即為您查詢。或於「會員中心 → 訂單」查看完整狀態。',
  序號: '若序號無法使用，請於 24 小時內回報，提供：訂單編號、嘗試輸入的遊戲帳號、系統錯誤訊息。我們將立即補發或全額退款。',
  GASH: 'GASH 點數可用於：新楓之谷、天堂、跑跑卡丁車、RO 仙境傳說、神魔之塔、龍之谷 M 等 200+ 款遊戲。儲值方式詳見商品頁的「儲值教學」。',
  退款: '未使用之未開卡序號 7 天內可申請全額退款。已使用之序號依遊戲商規定處理，我們將協助申訴。請告知訂單編號為您處理。',
  VIP: 'VIP 共五階（Bronze→Silver→Gold→Platinum→BLACK），最高享 8% 終身回饋。會員等級會自動依累積消費升級。',
};

function matchReply(msg) {
  for (const k of Object.keys(BOT_REPLIES)) {
    if (k !== 'default' && msg.includes(k)) return BOT_REPLIES[k];
  }
  return '已收到您的問題，正轉接至專員，平均回覆時間 < 1 分鐘，請稍候。';
}

export default function LiveChat() {
  const { drawer, closeDrawer } = useApp();
  const open = drawer.open === 'chat';
  const [floatOpen, setFloatOpen] = useState(false);
  const [msgs, setMsgs] = useState([
    { from: 'bot', text: BOT_REPLIES.default, time: '剛剛' },
  ]);
  const [input, setInput] = useState('');
  const [typing, setTyping] = useState(false);
  const scrollRef = useRef(null);

  const realOpen = open || floatOpen;

  useEffect(() => {
    if (realOpen) {
      setTimeout(() => {
        scrollRef.current?.scrollTo({ top: 9e9, behavior: 'smooth' });
      }, 50);
    }
  }, [msgs, realOpen]);

  const send = (text) => {
    if (!text.trim()) return;
    setMsgs((m) => [...m, { from: 'me', text, time: '剛剛' }]);
    setInput('');
    setTyping(true);
    setTimeout(() => {
      setTyping(false);
      setMsgs((m) => [...m, { from: 'bot', text: matchReply(text), time: '剛剛' }]);
    }, 700 + Math.random() * 600);
  };

  return (
    <>
      <button
        className={`nx-chat-fab ${realOpen ? 'is-open' : ''}`}
        onClick={() =>
          realOpen ? (closeDrawer(), setFloatOpen(false)) : setFloatOpen(true)
        }
        aria-label="客服協助"
      >
        <Icon name={realOpen ? 'close' : 'chat'} size={18} />
      </button>

      {realOpen && (
        <div className="nx-chat" role="dialog" aria-label="客服">
          <div className="nx-chat__head">
            <div className="nx-chat__head-info">
              <strong>QQCARD 客戶服務</strong>
              <span>線上 · 平均回覆 &lt; 1 分鐘</span>
            </div>
            <button
              className="nx-chat__head-close"
              onClick={() => {
                closeDrawer();
                setFloatOpen(false);
              }}
              aria-label="關閉"
            >
              <Icon name="close" size={14} />
            </button>
          </div>

          <div className="nx-chat__body" ref={scrollRef}>
            {msgs.map((m, i) => (
              <div key={i} className={`nx-chat__msg nx-chat__msg--${m.from}`}>
                <div className="nx-chat__bubble">
                  {m.text}
                  <time>{m.time}</time>
                </div>
              </div>
            ))}
            {typing && (
              <div className="nx-chat__msg nx-chat__msg--bot">
                <div className="nx-chat__bubble nx-chat__typing">
                  <span /><span /><span />
                </div>
              </div>
            )}
          </div>

          <div className="nx-chat__quick">
            {QUICK.map((q) => (
              <button key={q} onClick={() => send(q)}>
                {q}
              </button>
            ))}
          </div>

          <form
            className="nx-chat__form"
            onSubmit={(e) => {
              e.preventDefault();
              send(input);
            }}
          >
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="輸入訊息..."
              maxLength={500}
            />
            <button type="submit" disabled={!input.trim()} aria-label="送出">
              <Icon name="arrowRight" size={14} />
            </button>
          </form>
        </div>
      )}
    </>
  );
}
